import { StorageService } from '@morningstar/shared/base/storage-service';
import { QueryStringService } from '../../shared/query-string.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from '../login.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenLogin } from './token-login';
import { StorageTypes } from '@morningstar/shared/base/storage-service';

@Component({
  selector: 'wsg-token-login',
  templateUrl: './token-login.component.html',
  styleUrls: ['./token-login.component.css']
})
export class TokenLoginComponent implements OnInit {

  constructor(private loginService: LoginService, private router: Router, private route: ActivatedRoute,
              private snackbar: MatSnackBar, private storageService: StorageService) { }

  ngOnInit() {

    let returnUrl = this.route.snapshot.queryParams['returnUrl'];
    const returnToBceUrl = this.route.snapshot.queryParams['returnToBceUrl'];

    if (returnToBceUrl != null) {
      this.storageService.setItem(StorageTypes.bceLink, returnToBceUrl);
    }

    const q = this.route.snapshot.queryParams['q'];

    this.loginService.tokenLogin(q)
                     .subscribe(success => {
                       // this.router.navigate([returnUrl], { queryParamsHandling: 'preserve' });
                       let queryString = '';
                       let queryParameters = {};

                      if (returnUrl.indexOf('?') !== -1) {
                        queryString = returnUrl.split('?')[1];
                        returnUrl = returnUrl.split('?')[0];

                        queryParameters = this.parseQuery(queryString);

                        queryParameters['q'] = null;
                        queryParameters['returnUrl'] = null;
                      }

                       this.router.navigate([returnUrl]);
                     }, error => {
                       this.snackbar.open('Error logging in, please login again', 'DISMISS', { duration: 2000 });
                       this.router.navigate(['/login'],  { queryParams: { returnUrl: returnUrl }, queryParamsHandling: 'preserve' });
                       console.error(error.error);
                     });
  }

  parseQuery(queryString): {} {
    const query = {};
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }
}
